const loginPageTranslations = {
  formTitle: "Transform your body now with",
  formTitleHook: "Informa",
  subtitle: "You are one click away from changing your life",
  form: {
    username: "Username",
    password: "Password",
    submit: "Sign In",
  },
};

export default loginPageTranslations;
